














































































import { Component, Vue, Prop } from "vue-property-decorator";
import backIcon from "../../assets/images/back-icon.png";
import html2canvas from "html2canvas";
import moment from "moment";
@Component({
  components: {}
})
export default class Certificate extends Vue {
  private backIcon = backIcon;
  private certificate: any = {};
  private certificateInfo = {
    realName: "",
    sex: "",
    idCard: "",
    orgizationName: "",
    degree: "",
    major: "",
    certificateNo: "",
    certificateApplyAt: "",
    pic: "",
    credentialPushlishDate: ""
  };
  private exportImg = "";
  get origin() {
    return location.origin;
  }
  private sexMap = {
    MAN: "男",
    WOMAN: "女"
  };
  created() {
    const pathArr = ["/certificateQuery", "/certificate"];
    if (!pathArr.includes(this.$route.path)) {
      this.$router.push("/certificateQuery");
    }
    if (!localStorage.getItem("certificate")) {
      this.$message.info("请先输入查询信息");
      this.$router.push("/certificateQuery");
    }
    this.certificate = JSON.parse(localStorage.getItem("certificate") as any);
    if (this.certificate.data.data.pass) {
      this.certificateInfo = JSON.parse(
        localStorage.getItem("certificate") as any
      ).data.data.student;
      this.certificateInfo.sex = this.sexMap[this.certificateInfo.sex];
      this.certificateInfo.credentialPushlishDate = this.certificate.data.data.credentialPushlishDate;
      this.certificateInfo.certificateApplyAt = moment().format(
        "YYYY年MM月DD日"
      );
      Object.keys(this.certificateInfo).map(key => {
        if (!this.certificateInfo[key]) this.certificateInfo[key] = "";
      });
    }
  }
  private beforeDestroy() {
    localStorage.removeItem("certificate");
  }
  private onExportImageLoad() {
    (window as any).pageYoffset = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    const targetDom: any = document.getElementById("certificate");
    const opt = {
      background: "#ffffff",
      useCORS: true,
      scrollY: 0,
      scrollX: 0,
      height: targetDom.scrollHeight, //canvas高
      width: targetDom.scrollWidth, //canvas宽
      scale: 4, //按比例增加分辨率 (2=双倍).
      dpi: window.devicePixelRatio * 4
    };
    html2canvas(targetDom, opt).then(canvas => {
      this.exportImg = canvas.toDataURL("image/png");
      const base64ToBlob = function(code) {
        const parts = code.split(";base64,");
        const contentType = parts[0].split(":")[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
          type: contentType
        });
      };
      const aLink = document.createElement("a");
      const blob = base64ToBlob(this.exportImg); //new Blob([content]);
      const evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = "certificate.png";
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    });
  }
  private goBack() {
    this.$router.go(-1);
  }
}
